/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Hero_Highlight_OverviewsInputs */

const en_why_listening_hero_highlight_overviews = /** @type {(inputs: Why_Listening_Hero_Highlight_OverviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI overviews`)
};

const es_why_listening_hero_highlight_overviews = /** @type {(inputs: Why_Listening_Hero_Highlight_OverviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resúmenes con IA`)
};

/**
* | output |
* | --- |
* | "AI overviews" |
*
* @param {Why_Listening_Hero_Highlight_OverviewsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_hero_highlight_overviews = /** @type {((inputs?: Why_Listening_Hero_Highlight_OverviewsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Hero_Highlight_OverviewsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_hero_highlight_overviews(inputs)
	return en_why_listening_hero_highlight_overviews(inputs)
});